document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.getElementById('toggle-out-of-stock-variants');
  if (!toggle) return;

  // Function to handle out of stock variant visibility
  function handleOutOfStockVisibility() {
    const showOutOfStock = toggle.checked;
    const soldOutRows = document.querySelectorAll('.variant-item.sold-out');
    
    // Save preference to localStorage (only if customer doesn't have a metafield preference)
    if (!window.customerOutOfStockPreference) {
      localStorage.setItem('showOutOfStock', showOutOfStock);
    }
    
    soldOutRows.forEach(row => {
      row.style.display = showOutOfStock ? '' : 'none';
    });
  }

  // Check customer metafield preference first, then localStorage, then default to false
  let shouldShowOutOfStock = false;
  
  if (window.customerOutOfStockPreference) {
    // Handle both array and string formats
    const preference = Array.isArray(window.customerOutOfStockPreference) 
      ? window.customerOutOfStockPreference[0] 
      : window.customerOutOfStockPreference;
    shouldShowOutOfStock = preference === 'Show';
  } else {
    const savedPreference = localStorage.getItem('showOutOfStock');
    shouldShowOutOfStock = savedPreference === 'true';
  }
  
  toggle.checked = shouldShowOutOfStock;
  handleOutOfStockVisibility();
  
  // Add event listener for the out of stock toggle
  toggle.addEventListener('change', handleOutOfStockVisibility);
}); 